<script setup>
import SportLiveTvAlertIcon from '@/sport-live-tv/components/sport-live-tv-alert-icon.vue';
import SportLiveTvButton from '@/sport-live-tv/components/sport-live-tv-button.vue';
import SportLiveTvDialog from '@/sport-live-tv/components/sport-live-tv-dialog.vue';
import { useSportLiveTvTranslation } from '@/sport-live-tv/composables/use-sport-live-tv-translation';

defineProps({
  title: { type: String, required: true },
});

const emit = defineEmits(['retry', 'back']);

const { t } = useSportLiveTvTranslation();
</script>

<template>
  <SportLiveTvDialog>
    <div class="sport-live-tv-stream-error">
      <SportLiveTvAlertIcon />
      <h2 class="sport-live-tv-stream-error__title">{{ t('streamErrorTitle') }}</h2>
      <p class="sport-live-tv-stream-error__message">{{ t('streamErrorMessage', { title }) }}</p>
      <div class="sport-live-tv-stream-error__actions">
        <SportLiveTvButton variant="secondary" :label="t('backToSports')" @click="emit('back')" />
        <SportLiveTvButton :label="t('retry')" @click="emit('retry')" />
      </div>
    </div>
  </SportLiveTvDialog>
</template>

<style lang="scss" scoped>
.sport-live-tv-stream-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;

  &__title {
    margin: 0;
    color: $white;
    font-size: 20px;
    font-weight: 600;
  }

  &__message {
    margin: 0;
    color: $gray;
    font-size: 15px;
  }

  &__actions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;

    @include mobile-sm-max {
      flex-direction: column-reverse;
      align-items: stretch;
      width: 100%;
    }
  }
}
</style>
